<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerText]="data.typeOfSelector"
	[headerIcon]="{fontIcon: 'fa-edit', fontSet: 'fad'}"
	[matDialogData]="data"
	[rect]="rect"
	[smallHeader]="true"
>
	<div dialogContent>
		<div>
			@switch (data.typeOfSelector) {
				@case ("Framerate") {
					<div class="innerContent">
						<mat-form-field color="accent">
							<input [(ngModel)]="numOfFramerate" [max]="60" [min]="0" matInput name="Framerate" type="number" />
							<mat-hint>value must be less than or equal to 60</mat-hint>
						</mat-form-field>
						<button (click)="SetAllFramerate()" color="accent" mat-raised-button>change all Framerate</button>
					</div>
				}
				@case ("Compression") {
					<div class="innerContent">
						<mat-form-field color="accent">
							<input [(ngModel)]="numOfCompression" [max]="100" [min]="0" matInput name="compression" type="number" />
							<mat-hint>value must be less than or equal to 100</mat-hint>
						</mat-form-field>
						<button (click)="SetAllCompression()" color="accent" mat-raised-button>change all Compression</button>
					</div>
				}
				@case ("OutputFormat") {
					<div class="innerContent">
						<mat-form-field color="accent">
							<mat-select [(ngModel)]="selectedOutputFormat">
								@for (cameraDestinationFormat of cameraDestinationFormats; track cameraDestinationFormat) {
									<mat-option [value]="cameraDestinationFormat.value">
										{{ cameraDestinationFormat.name }}
									</mat-option>
								}
							</mat-select>
						</mat-form-field>
						<button (click)="SetAllOutputFormat()" color="accent" mat-raised-button>change all OutputFormat</button>
					</div>
				}
			}
		</div>
	</div>
</sim-basic-material-dialog>
